var Haiku = require("@haiku/core");
var _code_scribble_code = require("./../scribble/code.js");
var _code_zigzag_code = require("./../zigzag/code.js");
var _code_arrowdash_code = require("./../arrowdash/code.js");
module.exports = {
  metadata: {
    version: "0.0.1",
    username: "taylor+taylor@haiku.ai",
    organization: "taylor",
    project: "LearnPage",
    branch: "master",
    folder: "/Users/taylorpoe/.haiku/projects/taylor/LearnPage",
    uuid: "cda19af0-c606-42a6-8d4b-27dc22f4ae19",
    root: "https://cdn.haiku.ai/fcc9dcae-e947-46b4-93c1-3d8124b73118/2052390f1eca947b5c1e3efd709218e226c7eefe/",
    core: "4.3.5",
    title: "Main",
    type: "haiku",
    relpath: "code/main/code.js"
  },
  options: {},
  states: {},
  eventHandlers: {},
  timelines: {
    Default: {
      "haiku:Main-03757d2ca1026e0a": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "hidden",
        "style.overflowY": "hidden",
        "sizeAbsolute.x": 900,
        "sizeAbsolute.y": 350,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1,
        "style.backgroundColor": { "0": { value: "#FFB2D1", edited: true } }
      },
      "haiku:Learn-c13098b4ca3d36bf": {
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 498,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 73,
        "sizeMode.y": 1,
        "translation.x": 450,
        "translation.y": 175,
        "style.zIndex": 4
      },
      "haiku:Arrowdash-9546ba400be29339": {
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeAbsolute.x": "auto",
        "sizeAbsolute.y": "auto",
        "translation.x": 129.053,
        "translation.y": 145.9715,
        "origin.x": 0.5,
        "origin.y": 0.5,
        "style.zIndex": 1
      },
      "haiku:Zigzag-3cc7eba9094ad34e": {
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeAbsolute.x": "auto",
        "sizeAbsolute.y": "auto",
        "translation.x": 471.89200000000005,
        "translation.y": 176,
        "origin.x": 0.5,
        "origin.y": 0.5,
        "style.zIndex": 2
      },
      "haiku:Scribble-6c92ac9953fe3bcc": {
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeAbsolute.x": "auto",
        "sizeAbsolute.y": "auto",
        "translation.x": 710.9819677734375,
        "translation.y": 233.199,
        "origin.x": 0.5,
        "origin.y": 0.5,
        "style.zIndex": 3
      },
      "haiku:Page-1-5e4c8fd190602908": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Artboard-d9352d87e107b4e8": {
        fill: "#177191",
        "translation.x": -201,
        "translation.y": -139
      },
      "haiku:Learn-76034be0f6415534": {
        d:
          "M201,209.1 L201,142.9 C201,141.9 201.791878,141 202.880711,141 L209.413706,141 C210.403553,141 211.294416,141.9 211.294416,142.9 L211.294416,201.7 L238.119289,201.7 C239.208122,201.7 240,202.6 240,203.6 L240,209.1 C240,210.1 239.208122,211 238.119289,211 L202.880711,211 C201.791878,211 201,210.1 201,209.1 Z M300,209.1 L300,142.9 C300,141.9 300.803653,141 301.908676,141 L342.091324,141 C343.196347,141 344,141.9 344,142.9 L344,148.5 C344,149.5 343.196347,150.4 342.091324,150.4 L310.347032,150.4 L310.347032,170.8 L337.16895,170.8 C338.173516,170.8 339.077626,171.7 339.077626,172.7 L339.077626,178.3 C339.077626,179.4 338.173516,180.2 337.16895,180.2 L310.347032,180.2 L310.347032,201.7 L342.091324,201.7 C343.196347,201.7 344,202.6 344,203.6 L344,209.1 C344,210.1 343.196347,211 342.091324,211 L301.908676,211 C300.803653,211 300,210.1 300,209.1 Z M400.900345,210 C399.400362,210 398.600371,208.7 399.200364,207.4 L429.900023,140.1 C430.20002,139.5 431.10001,139 431.600004,139 L432.599993,139 C433.099988,139 433.999978,139.5 434.299974,140.1 L464.799636,207.4 C465.399629,208.7 464.599638,210 463.099655,210 L456.799725,210 C455.599738,210 454.899746,209.4 454.49975,208.5 L448.299819,194.8 L415.600182,194.8 C413.600204,199.4 411.500228,203.9 409.50025,208.5 C409.200253,209.2 408.400262,210 407.200275,210 L400.900345,210 Z M420,186 L445,186 L432.7,159 L432.2,159 L420,186 Z M524,209.1 L524,142.9 C524,141.9 524.801572,141 525.903733,141 L553.157171,141 C565.180747,141 575,150.5 575,162.4 C575,171.6 568.888016,179.2 560.170923,182.7 L573.897839,208.1 C574.599214,209.4 573.897839,211 572.194499,211 L564.379175,211 C563.577603,211 562.976424,210.5 562.776031,210.1 L549.449902,183.6 L534.320236,183.6 L534.320236,209.1 C534.320236,210.1 533.418468,211 532.416503,211 L525.903733,211 C524.801572,211 524,210.1 524,209.1 Z M535,174 L552.8,174 C559.3,174 565,168.567901 565,161.753086 C565,155.333333 559.3,150 552.8,150 L535,150 L535,174 Z M641,209.1 L641,141.8 C641,140.8 641.898451,140 642.89673,140 L645.392427,140 L688.717728,190.2 C688.717728,190.2 688.817556,190.2 688.817556,190.2 L688.817556,142.9 C688.817556,141.9 689.616179,141 690.714286,141 L697.10327,141 C698.101549,141 699,141.9 699,142.9 L699,210.2 C699,211.2 698.101549,212 697.10327,212 L694.507745,212 L651.182444,160.4 C651.182444,160.4 651.082616,160.4 651.082616,160.4 L651.082616,209.1 C651.082616,210.1 650.283993,211 649.185886,211 L642.89673,211 C641.898451,211 641,210.1 641,209.1 Z"
      }
    }
  },
  template: {
    elementName: "div",
    attributes: { "haiku-id": "Main-03757d2ca1026e0a", "haiku-title": "Main" },
    children: [
      {
        elementName: _code_scribble_code,
        attributes: {
          "haiku-id": "Scribble-6c92ac9953fe3bcc",
          "haiku-var": "_code_scribble_code",
          "haiku-title": "Scribble",
          "haiku-source": "./code/scribble/code.js"
        },
        children: []
      },
      {
        elementName: _code_zigzag_code,
        attributes: {
          "haiku-id": "Zigzag-3cc7eba9094ad34e",
          "haiku-var": "_code_zigzag_code",
          "haiku-title": "Zigzag",
          "haiku-source": "./code/zigzag/code.js"
        },
        children: []
      },
      {
        elementName: _code_arrowdash_code,
        attributes: {
          "haiku-id": "Arrowdash-9546ba400be29339",
          "haiku-var": "_code_arrowdash_code",
          "haiku-title": "Arrowdash",
          "haiku-source": "./code/arrowdash/code.js"
        },
        children: []
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Learn-c13098b4ca3d36bf",
          "haiku-title": "Learn",
          "haiku-source": "designs/LearnPage.sketch.contents/slices/Learn.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-5e4c8fd190602908", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Artboard-d9352d87e107b4e8",
                  id: "Artboard"
                },
                children: [
                  {
                    elementName: "path",
                    attributes: {
                      "haiku-id": "Learn-76034be0f6415534",
                      id: "Learn"
                    },
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/taylor-learnpage/code/main/code.js
// module id = 530
// module chunks = 127651196306611